export const IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION';
export var IDVQrCodeStatus;
(function (IDVQrCodeStatus) {
    IDVQrCodeStatus["STARTED"] = "STARTED";
    IDVQrCodeStatus["COMPLETED"] = "COMPLETED";
    IDVQrCodeStatus["ERROR"] = "ERROR";
})(IDVQrCodeStatus || (IDVQrCodeStatus = {}));
//# sourceMappingURL=idv-qr-code.interface.js.map